/**
 * shared/src/schemas/location.schema.ts
 *
 * Shared DTO schemas for GPS location and position data.
 */
import { z } from 'zod';
export const PositionInputSchema = z.object({
    userId: z.string().uuid(),
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    speed: z.number().min(0).max(400),
    heading: z.number().min(0).max(360),
    batteryPct: z.number().int().min(0).max(100).optional(),
    sessionId: z.string().uuid().optional(),
    routeId: z.string().uuid().optional(),
    timestamp: z.string().datetime().optional(),
});
export const BatchPointsInputSchema = z.object({
    points: z.array(z.object({
        lat: z.number().min(-90).max(90),
        lng: z.number().min(-180).max(180),
        ts: z.number(),
        accuracy_m: z.number().min(0).max(500).nullable().optional(),
        speed_kmh: z.number().min(0).max(400).nullable().optional(),
    })),
});
//# sourceMappingURL=location.schema.js.map